import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      {/* <div class="theme-element timer-element">
        <picture>
          <img
            src="../images/timer-left-element.svg"
            width="100%"
            alt="Element"
          />
        </picture>
      </div> */}
      {/* <div class="theme-element timer-element-right">
        <picture>
          <img
            src="../images/timer-right-element.svg"
            width="100%"
            alt="Element"
          />
        </picture>
      </div> */}
      <div class="over1">
        <h1
          class="d-block section-heading color-primary text-capitalize"
          style={{ marginBottom: "1.25rem" }}
        >
          {project} - Project Overview
        </h1>
        <p>
          Welcome to Raymonds Mahim, a premium residential development offering
          2, 3 & 4 BHK spacious residences in one of Mumbai’s most sought-after
          neighborhoods. Designed for those who seek luxury, comfort, and
          seamless connectivity, this project promises an elevated urban living
          experience. Strategically positioned in Mahim, this development
          ensures effortless access to key business hubs, entertainment
          destinations, and reputed educational institutions, making it an ideal
          address for both professionals and families.
          {/* <strong>
            Pre-Launch Booking Open – Secure Your Dream Home Today!
          </strong> */}
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          Highlights of Raymonds Mahim
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>
                  Spacious 2, 3 & 4 BHK Residences with Thoughtful Layouts
                </span>
              </li>
              <li>
                <span>
                  Located in the Heart of Mahim – Seamless Connectivity Across
                  Mumbai
                </span>
              </li>
              <li>
                <span>World-Class Amenities for a Modern Lifestyle</span>
              </li>
              {/* <li>
                <span>Grand Clubhouse With World Class Amenities</span>
              </li> */}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>Designed for Maximum Natural Light & Ventilation</span>
              </li>
              <li>
                <span>Gated Community with 24/7 Security & Smart Access</span>
              </li>
              <li>
                <span>
                  Surrounded by Top Schools, Hospitals & Shopping Hubs
                </span>
              </li>
              {/* <li>
                <span>
                  Easy Access to BKC & Western Expressway & Major Business Hubs
                </span>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={handleShowModal}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
